<!-- Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved. -->
<mat-card appearance="raised" [ngStyle]="{'height': componentHeight}" style="padding: 5px 0;">
    <div class="component-header">
        <p class="component-label">
          <span class="draggable">{{fThreatTitle}}</span>
          <a [routerLink]="['/history']" [queryParams]="getHeaderQueryParams()">
            <span class="mdi mdi-open-in-new open-icon link"></span>
          </a>
        </p>
        <mat-checkbox color="primary" [(ngModel)]="showTotal" (change)="receiveAlertsChanged($event)">
            <mat-label >{{fThreatShow}}</mat-label>
        </mat-checkbox>
    </div>
    <div #containerRef class="chart-area" [ngStyle]="{'height': graphStyle}">
        <div class="chart">
            <ngx-charts-line-chart
                [view]="[containerRef.offsetWidth, containerRef.offsetHeight]"
                [results]="data"
                [legend]="showLegend"
                [xAxis]="showXAxis"
                [yAxis]="showYAxis"
                scheme='vivid'
                style="fill: #919191;"
             >
             </ngx-charts-line-chart>
        </div>
    </div>
    <div style="margin-left: 15px;">
        <span>{{fThreatInfo}}</span>
    </div>
</mat-card>
